import FormControl from '@material-ui/core/FormControl';
import Popper from '@material-ui/core/Popper';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React, { useEffect, useState } from 'react';

import { useAppSelector } from '../../../store';

const IconSelect = () => (
    <svg className="icon-select" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 9L12 15L18 9" stroke="#6C6C7D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const SpecialMomentsDetails = ({
    specialMomentsDetails,
    setIsActionId,
    handleChange,
    OtherActionDescription,
    isTouched,
    setIsOther,
    isOther,
}: any) => {
    const [planValue, setPlanValue] = useState<any>([]);
    const { words } = useAppSelector(state => state.localization);

    const specialMomentChange = (e, val) => {
        if (val) {
            setIsOther(val.description === (words && words['WEB.other']));
            setIsActionId(val.id);
            setPlanValue(val);
        }
    };

    const handleOtherActionChange = e => {
        handleChange(e);
    };

    useEffect(() => {
        setPlanValue(specialMomentsDetails?.actions?.length === 1 ? specialMomentsDetails?.actions[0] : '');
    }, [specialMomentsDetails]);

    useEffect(() => {
        setIsActionId(planValue.id);
        setIsOther(planValue.description === (words && words['WEB.other']));
    }, [planValue]);

    const CustomPopper2 = function (props) {
        return <Popper {...props} className="modal-10" x-placement="bottom" />;
    };

    return (
        <>
            {specialMomentsDetails?.actionGroup && (
                <>
                    <div className="micro-card-05">
                        <div className="c-item-01">
                            <div className="c-item-01-A">
                                <img src={specialMomentsDetails.imageURL} alt={specialMomentsDetails.name} className="c-unit-01" />
                                <h2 className="c-unit-02">
                                    {specialMomentsDetails.name} {words && words['WEB.dayDetails']}
                                </h2>
                                <Tooltip
                                    id="tooltips"
                                    placement="top-end"
                                    arrow
                                    title={specialMomentsDetails?.actionFlows?.map(item => {
                                        return <div key={item?.description}>- {item?.description}</div>;
                                    })}
                                    className="c-item-02-B">
                                    <div className="c-unit-03">
                                        <svg
                                            className="c-unit-03-A"
                                            width="20"
                                            height="20"
                                            viewBox="0 0 20 20"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M10.0003 18.3333C14.6027 18.3333 18.3337 14.6023 18.3337 9.99996C18.3337 5.39759 14.6027 1.66663 10.0003 1.66663C5.39795 1.66663 1.66699 5.39759 1.66699 9.99996C1.66699 14.6023 5.39795 18.3333 10.0003 18.3333Z"
                                                stroke="#00A3FF"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M7.5752 7.49999C7.77112 6.94304 8.15782 6.47341 8.66682 6.17426C9.17583 5.87512 9.77427 5.76577 10.3562 5.86558C10.9381 5.96539 11.4659 6.26792 11.8461 6.71959C12.2263 7.17126 12.4344 7.74292 12.4335 8.33332C12.4335 9.99999 9.93353 10.8333 9.93353 10.8333"
                                                stroke="#00A3FF"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M10 14.1666H10.0083"
                                                stroke="#00A3FF"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                        <label className="c-unit-03-B">{words && words['WEB.whatCanWeDone']}</label>
                                    </div>
                                </Tooltip>
                                <Tooltip
                                    id="tooltips"
                                    placement="top-end"
                                    arrow
                                    title={specialMomentsDetails?.testimonials?.map(item => {
                                        return <div key={item?.description}>- {item?.description}</div>;
                                    })}
                                    className="c-item-02-B">
                                    <div className="c-unit-04">
                                        <svg
                                            className="c-unit-04-A"
                                            width="20"
                                            height="20"
                                            viewBox="0 0 20 20"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M17.5 12.5C17.5 12.942 17.3244 13.366 17.0118 13.6785C16.6993 13.9911 16.2754 14.1667 15.8333 14.1667H5.83333L2.5 17.5V4.16667C2.5 3.72464 2.67559 3.30072 2.98816 2.98816C3.30072 2.67559 3.72464 2.5 4.16667 2.5H15.8333C16.2754 2.5 16.6993 2.67559 17.0118 2.98816C17.3244 3.30072 17.5 3.72464 17.5 4.16667V12.5Z"
                                                stroke="#00A3FF"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                        <label className="c-unit-04-B">{words && words['WEB.oneOfUs']}</label>
                                    </div>
                                </Tooltip>
                            </div>
                            <p className="c-item-01-B">{specialMomentsDetails?.actionGroup?.description}</p>
                        </div>
                    </div>

                    <div className="c-item-plan">
                        <label className="c-item-plan-01">{words && words['WEB.createPlan']}</label>

                        {specialMomentsDetails?.actions && (
                            <FormControl variant="outlined" className="c-item-03-A form-group-03">
                                <label>
                                    {words && words['WEB.planType']}
                                    <span className="form-opsiyonel"> ({words && words['WEB.optional']})</span>
                                </label>
                                <Autocomplete
                                    fullWidth={true}
                                    noOptionsText={words && words['WEB.resultNotFounded']}
                                    autoSelect={true}
                                    PopperComponent={CustomPopper2}
                                    closeIcon=""
                                    value={planValue}
                                    id="specialDateId"
                                    onChange={(e, val) => specialMomentChange(e, val)}
                                    getOptionLabel={(option: any): any => option && option.description}
                                    options={specialMomentsDetails?.actions ? specialMomentsDetails?.actions : []}
                                    className="autocomplete-04"
                                    renderInput={params => (
                                        <>
                                            <TextField placeholder={words && words['WEB.choose']} {...params} />
                                            <IconSelect />
                                        </>
                                    )}
                                />
                            </FormControl>
                        )}

                        {(planValue.description === (words && words['WEB.other']) || isOther) && (
                            <FormControl variant="outlined" className={isTouched ? 'textfield-01 not-valid' : 'textfield-01'}>
                                <label>{words && words['WEB.other']}</label>
                                <TextField
                                    id="outlined-helperText"
                                    variant="outlined"
                                    name="OtherActionDescription"
                                    value={OtherActionDescription}
                                    onChange={e => handleOtherActionChange(e)}
                                />
                            </FormControl>
                        )}
                    </div>
                </>
            )}
        </>
    );
};

export default SpecialMomentsDetails;
